export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "تقييمات النزلاء",
    subtitle: "اطلب تقييمًا عبر واتساب يوم المغادرة. اضبط الرابط الذي تريد أن يترك النزلاء رأيهم فيه.",
    bulkNotice: "سيُطبَّق هذا التغيير على جميع أماكن الإقامة الـ {count} المرتبطة بهذا الإعلان.",
    enableTitle: "تفعيل تقييمات النزلاء",
    enableSub: "تُرسَل رسالة عبر واتساب تلقائيًا يوم المغادرة لطلب تقييم.",
    modeSingleTitle: "رابط واحد",
    modeSingleSub: "نفسه لجميع الحجوزات",
    modePerOtaTitle: "رابط لكل OTA",
    modePerOtaSub: "بحسب قناة الحجز",
    linkLabel: "رابط التقييمات",
    singleUrlPlaceholder: "https://g.page/r/… أو رابط موقع التقييمات",
    otaNamePlaceholder: "اسم الموقع",
    otaUrlPlaceholder: "https://… رابط التقييمات",
    removeTitle: "إزالة",
    addOta: "إضافة موقع آخر",
    saving: "جارٍ الحفظ…",
    saveConfig: "حفظ الإعدادات",
    note: "سيتلقّى النزلاء الرابط المناسب بحسب طريقة حجزهم.",
    toastLoadError: "تعذّر تحميل بيانات الإعلان.",
    urlErrorProtocol: "يجب أن يبدأ الرابط بـ http:// أو https://",
    urlErrorInvalid: "أدخل رابطًا صحيحًا (مثال: https://g.page/...)",
    toastStateUpdated: "تم تحديث الحالة بنجاح",
    toastStateError: "حدث خطأ أثناء تحديث الحالة",
    toastUrlRequired: "أدخل رابطًا قبل الحفظ",
    toastSaved: "تم حفظ الإعدادات بنجاح",
    toastSaveError: "حدث خطأ أثناء الحفظ",
  },

  // AccessSummary.vue
  access: {
    tag: "الأقفال والدخول",
    dynamicTitle: "قفل ذكي متصل",
    dynamicDetail: "يُنشئ كل حجز رمزًا جديدًا تلقائيًا ويُرسَل إلى النزيل.",
    chipCheckin: "يُرسَل عند إتمام تسجيل الوصول",
    chipTime: "يُرسَل في الساعة {time} يوم الوصول",
    chipManual: "ترسله أنت يدويًا",
    staticTitle: "قفل برمز ثابت",
    staticDetail: "يتلقّى النزيل رمز الصندوق أو القفل للدخول.",
    noneTitle: "أُسلّم المفاتيح باليد",
    noneDetail: "تنسّق تسليم المفتاح مع النزيل عند وصوله.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "تحديث السعر",
    saving: "جارٍ الحفظ…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "اربط كل وحدة من هذا الإعلان بمنشأتها في Mossos (يمكن أن يكون لكل وحدة معرّف شرطة خاص بها). تُرسَل عمليات تسجيل الوصول تلقائيًا إلى المنشأة الصحيحة بحسب وحدة الحجز.",
    wholeListing: "الإعلان بالكامل",
    wholeListingDefault: "الإعلان بالكامل (افتراضي)",
    unitNumber: "الوحدة #{id}",
    badgeSendError: "خطأ في الإرسال",
    badgeConnected: "متصل",
    badgeNoCredentials: "لا توجد بيانات اعتماد",
    emptyList: "لا توجد اتصالات بعد. أضف واحدًا لكل وحدة من الإعلان.",
    addConnection: "إضافة اتصال",
    editConnection: "تعديل الاتصال",
    newConnection: "اتصال جديد",
    unit: "الوحدة",
    unitPlaceholder: "اختر الوحدة",
    unitHint: "الوحدة التي تنتمي إليها هذه المنشأة من الإعلان.",
    step1Title: "الدخول إلى موقع Mossos",
    usuariLabel: "usuari (موقع Mossos)",
    savedHint: "محفوظ",
    usuariPlaceholderKeep: "اتركه فارغًا لعدم التغيير",
    usuariPlaceholderNew: "اسم مستخدم الدخول إلى الموقع",
    passLabel: "paraula de pas",
    passBlankHint: "فارغ لعدم التغيير",
    passPlaceholder: "كلمة مرور موقع Mossos",
    validateHint: "تحقّق لجلب المنشآت في حسابك.",
    searching: "جارٍ البحث…",
    validateSearch: "تحقّق وابحث عن المنشآت",
    step2Title: "منشأة هذه الوحدة",
    establishmentPlaceholder: "اختر المنشأة",
    revalidateHint: "تحقّق مجددًا لتغييرها.",
    validateAbove: "تحقّق أعلاه لاختيار منشأة هذه الوحدة.",
    checkinTime: "وقت الاحتساب (الوصول)",
    checkoutTime: "وقت المغادرة",
    cancel: "إلغاء",
    savingBtn: "جارٍ الحفظ...",
    updateConnection: "تحديث الاتصال",
    saveConnection: "حفظ الاتصال",
    warnCredentials: "أدخل usuari وparaula de pas الخاصة بموقع Mossos.",
    foundEstablishments: "تم العثور على {count} منشأة (منشآت). اختر منشأة هذه الوحدة.",
    noEstablishments: "لم يتم العثور على منشآت في هذا الحساب.",
    connectError: "تعذّر الاتصال بـ Mossos. تحقّق من usuari وكلمة المرور.",
    validateFirst: "تحقّق واختر منشأة هذا الاتصال.",
    savedOk: "تم حفظ اتصال Mossos.",
    saveError: "تعذّر حفظ الاتصال.",
    saveErrorGeneric: "خطأ أثناء حفظ اتصال Mossos.",
    confirmDelete: `حذف اتصال "{unit}" ({id})؟`,
    deletedOk: "تم حذف الاتصال.",
    deleteError: "تعذّر حذف الاتصال.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "كل وحدة تُبلّغ عن ضيوفها عبر حساب SES Hospedajes. يمكنك استخدام حساب واحد للإعلان بالكامل أو تعيين حساب مختلف لبعض الوحدات، مثلًا إذا كان لكل شقة رمز منشأة خاص بها.",
    defaultName: "المنشأة {code}",
    badgeConnected: "متصل",
    badgeError: "خطأ في التحقق",
    badgePending: "لم يتم التحقق",
    user: "المستخدم",
    lessor: "المؤجّر",
    establishment: "المنشأة",
    appliesWhole: "الإعلان بالكامل:",
    appliesUnits: "الوحدات:",
    noUnits: "لا تستخدمه أي وحدة",
    allUnits: "جميع الوحدات ({count})",
    moreUnits: "+{count} أخرى",
    andMore: "و{count} أخرى",
    emptyList: "لم تربط أي حساب SES Hospedajes بعد.",
    withoutAccountTitle: "بدون حساب:",
    withoutAccountText: "لا يتم إبلاغ SES Hospedajes بعمليات تسجيل الوصول الخاصة بها.",
    addAccount: "إضافة حساب",
    edit: "تعديل",
    remove: "إزالة",
    newTitle: "حساب SES Hospedajes جديد",
    editTitle: "تعديل حساب SES Hospedajes",
    aliasLabel: "اسم الحساب (اختياري)",
    aliasPlaceholder: "مثال: البنتهاوس، الشقة 2B",
    aliasHint: "يُستخدم فقط للتعرّف عليه هنا. إذا تُرك فارغًا يُعرض الحساب برمز المنشأة.",
    loginTitle: "الدخول إلى الوزارة",
    loginSame: "نفس المستخدم وكلمة المرور",
    loginSameHint: "تكتب فقط رموز هذا الحساب.",
    loginOwn: "مستخدم وكلمة مرور آخران",
    loginFrom: "استخدام بيانات الدخول من",
    passwordKeep: "اتركها فارغة لعدم تغييرها",
    passwordNeeded: "اكتب كلمة مرور المستخدم الجديد.",
    passwordShared: "يستخدم هذا المستخدمَ {count} حساب آخر في الإعلان: إذا غيّرت كلمة المرور فستُحدَّث فيها جميعًا.",
    scopeTitle: "على أي وحدات ينطبق؟",
    scopeWhole: "الإعلان بالكامل",
    scopeWholeHint: "تستخدمه الوحدات التي ليس لها حساب آخر.",
    scopeWholeTaken: "«{name}» هو كذلك بالفعل.",
    scopeUnits: "بعض الوحدات فقط",
    scopeUnitsHint: "أنت تختار أيّها.",
    unitNow: "الآن: {name}",
    unitNowWhole: "الآن: حساب الإعلان بالكامل",
    unitNowNone: "بدون حساب",
    leftWithout: "بدون حساب بعد الحفظ. سيتوقف إبلاغ SES Hospedajes بعمليات تسجيل الوصول الخاصة بها.",
    leftToWhole: "بعد الحفظ سيتم الإبلاغ عبر حساب الإعلان بالكامل «{name}».",
    errUnits: "اختر وحدة واحدة على الأقل.",
    errDefaultExists: "لهذا الإعلان حساب لجميع وحداته بالفعل.",
    errDuplicate: "لديك هذا الحساب بالفعل في هذا الإعلان. عدّله وأضف إليه وحدات.",
    errCopyFrom: "تعذّر استخدام بيانات الدخول من ذلك الحساب. اكتبها يدويًا.",
    savedValidated: "تم حفظ الحساب والتحقق منه لدى الوزارة.",
    savedNotValidated: "تم الحفظ، لكن الوزارة لا تقبل البيانات. راجعها.",
    savedUnchecked: "تم حفظ الحساب. لا يتيح TRA التحقق من الرمز مسبقًا: سيتضح ذلك عند أول إرسال.",
    passwordSynced: "تم تحديث كلمة المرور أيضًا في {count} حساب بنفس المستخدم.",
    removeTitle: "إزالة هذا الحساب؟",
    removeNoUnits: "ستتم إزالة الحساب «{name}». لا تستخدمه أي وحدة.",
    removeToFallback: "ستتم إزالة «{name}». الوحدات التي تستخدمه ({units}) ستُبلّغ عبر حساب الإعلان بالكامل «{fallback}».",
    removeToNothing: "ستتم إزالة «{name}». الوحدات التي تستخدمه ({units}) ستبقى بدون حساب وسيتوقف إبلاغ SES Hospedajes بعمليات تسجيل الوصول الخاصة بها.",
    removeConfirm: "نعم، إزالة",
    removed: "تمت إزالة الحساب.",
    removeError: "تعذّرت إزالة الحساب.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "جارٍ تحميل الحسابات…",
    saving: "جارٍ الحفظ…",
    close: "إغلاق",
    show: "إظهار",
    hide: "إخفاء",

    badgeConnected: "متصل",
    badgeError: "خطأ في التحقق",
    badgePending: "لم يتم التحقق",
    badgeOnSend: "يتم التحقق عند الإرسال",

    edit: "تعديل",
    remove: "إزالة",
    addAccount: "إضافة حساب",

    appliesWhole: "الإعلان بالكامل:",
    appliesUnits: "الوحدات:",
    noUnits: "لا تستخدمه أي وحدة",
    allUnits: "جميع الوحدات ({count})",
    moreUnits: "+{count} أخرى",
    andMore: "و{count} أخرى",
    withoutAccountTitle: "بدون حساب:",

    scopeTitle: "على أي وحدات ينطبق؟",
    scopeWhole: "الإعلان بالكامل",
    scopeWholeHint: "تستخدمه الوحدات التي ليس لها حساب آخر.",
    scopeWholeTaken: "«{name}» هو كذلك بالفعل.",
    scopeUnits: "بعض الوحدات فقط",
    scopeUnitsHint: "أنت تختار أيّها.",
    unitNow: "الآن: {name}",
    unitNowWhole: "الآن: حساب الإعلان بالكامل",
    unitNowNone: "بدون حساب",
    leftToWhole: "بعد الحفظ سيتم الإبلاغ عبر حساب الإعلان بالكامل «{name}».",

    aliasLabel: "اسم الحساب (اختياري)",
    aliasPlaceholder: "مثال: البرج الشمالي، الشقة 301",
    loginFrom: "استخدام بيانات الدخول من",
    secretKeep: "اتركه فارغًا لعدم تغييره",

    errUnits: "اختر وحدة واحدة على الأقل.",
    errDefaultExists: "لهذا الإعلان حساب لجميع وحداته بالفعل.",
    errDuplicate: "لديك هذا الحساب بالفعل في هذا الإعلان. عدّله وأضف إليه وحدات.",
    errCopyFrom: "تعذّر استخدام بيانات الدخول من ذلك الحساب. اكتبها يدويًا.",
    errNoListing: "لم نجد الإعلان. أعد فتح الشاشة.",
    saveError: "تعذّر حفظ الحساب.",

    removeTitle: "إزالة هذا الحساب؟",
    removeConfirm: "نعم، إزالة",
    removeNoUnits: "ستتم إزالة الحساب «{name}». لا تستخدمه أي وحدة.",
    removeToFallback: "ستتم إزالة «{name}». الوحدات التي تستخدمه ({units}) ستُبلّغ عبر حساب الإعلان بالكامل «{fallback}».",
    removeToNothing: "ستتم إزالة «{name}». الوحدات التي تستخدمه ({units}) ستبقى بدون حساب وستتوقف عن الإبلاغ إلى {authority}.",
    removed: "تمت إزالة الحساب.",
    removeError: "تعذّرت إزالة الحساب.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "كل وحدة تُبلّغ عن ضيوفها إلى SIRE عبر حساب. يمكنك استخدام حساب واحد للإعلان بالكامل أو تعيين حساب مختلف لبعض الوحدات، مثلًا إذا كانت كل شقة مسجَّلة برمز منشأة خاص بها.",
      introSingle: "اربط الحساب الذي يُبلّغ به هذا الإعلان عن ضيوفه إلى SIRE.",
      emptyList: "لم تربط أي حساب SIRE بعد.",
      withoutAccountText: "لا يتم إبلاغ SIRE بعمليات تسجيل الوصول الخاصة بها.",
      newTitle: "حساب SIRE جديد",
      editTitle: "تعديل حساب SIRE",
      modalSub: "هي البيانات التي تدخل بها إلى SIRE",
      defaultName: "المنشأة {code}",
      defaultNameDoc: "المستند {document}",
      docTypeLabel: "نوع المستند",
      docType_CO_ID: "بطاقة هوية المواطن (cédula de ciudadanía)",
      docType_CO_FID: "بطاقة هوية الأجنبي (cédula de extranjería)",
      documentLabel: "رقم المستند",
      documentPlaceholder: "مثال: 1012345678",
      documentHint: "هو المستخدم الذي تدخل به إلى SIRE.",
      passwordLabel: "كلمة المرور",
      passwordPlaceholder: "كلمة مرور SIRE",
      passwordShared: "يستخدم هذا المستندَ {count} حساب آخر في الإعلان: إذا غيّرت كلمة المرور فستُحدَّث فيها جميعًا.",
      estLabel: "رمز المنشأة (اختياري)",
      estPlaceholder: "مثال: 67890",
      estHint: "لا يلزم إلا إذا كنت تُبلّغ عن عدة أماكن إقامة بنفس بيانات الدخول. إذا تركته فارغًا يُستخدم الرمز المسجَّل لديك.",
      loginTitle: "الدخول إلى SIRE",
      loginSame: "نفس المستند وكلمة المرور",
      loginSameHint: "تكتب فقط رمز هذا الحساب.",
      loginOwn: "مستند وكلمة مرور آخران",
      aliasHint: "يُستخدم فقط للتعرّف عليه هنا. إذا تُرك فارغًا يُعرض الحساب برمز المنشأة.",
      metaDoc: "المستند",
      metaEst: "المنشأة",
      leftWithout: "بدون حساب بعد الحفظ. سيتوقف إبلاغ SIRE بعمليات تسجيل الوصول الخاصة بها.",
      errDocument: "اكتب رقم المستند.",
      errPassword: "اكتب كلمة مرور SIRE.",
      errPasswordNeeded: "اكتب كلمة مرور المستند الجديد.",
      savedValidated: "تم حفظ الحساب والتحقق منه لدى SIRE.",
      savedNotValidated: "تم الحفظ، لكن SIRE لا يقبل البيانات. راجعها.",
      savedUnchecked: "تم حفظ الحساب. لا يتيح TRA التحقق من الرمز مسبقًا: سيتضح ذلك عند أول إرسال.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "كل وحدة ترسل تقريرها إلى TRA عبر حساب. يمكنك استخدام حساب واحد للإعلان بالكامل أو تعيين حساب مختلف لبعض الوحدات: كل RNT يحدّد مكان إقامة واحدًا.",
      introSingle: "اربط الحساب الذي يرسل به هذا الإعلان تقريره إلى TRA.",
      emptyList: "لم تربط أي حساب TRA بعد.",
      withoutAccountText: "لا يتم إبلاغ TRA بإقامات هذه الوحدات.",
      newTitle: "حساب TRA جديد",
      editTitle: "تعديل حساب TRA",
      modalSub: "هما الـ token و الـ RNT الخاصان بمكان الإقامة هذا",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "الصق هنا الـ token الخاص بك",
      tokenHint: "تُنشئه في",
      loginTitle: "الدخول إلى TRA",
      loginSame: "نفس الـ token",
      loginSameHint: "تكتب فقط الـ RNT الخاص بهذا الحساب.",
      loginOwn: "token آخر",
      rntLabel: "RNT",
      rntPlaceholder: "مثال: 123456",
      rntHint: "الـ Registro Nacional de Turismo الخاص بمكان الإقامة هذا. هو ما يحدّد المنشأة لدى TRA.",
      aliasHint: "يُستخدم فقط للتعرّف عليه هنا. إذا تُرك فارغًا يُعرض الحساب برقم RNT الخاص به.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "بدون حساب بعد الحفظ. سيتوقف إبلاغ TRA بإقامات هذه الوحدات.",
      errToken: "الصق الـ token الخاص بـ TRA.",
      errRnt: "الـ RNT رقم. راجعه.",
      savedValidated: "تم حفظ الحساب والتحقق منه لدى TRA.",
      savedNotValidated: "تم الحفظ، لكن TRA لا يقبل البيانات. راجعها.",
      savedUnchecked: "تم حفظ الحساب. لا يتيح TRA التحقق من الرمز مسبقًا: سيتضح ذلك عند أول إرسال.",
    },

    foreign: {
      ses: "SES Hospedajes (إسبانيا)",
      colombia: "SIRE و TRA (كولومبيا)",
      title: "لا تزال هناك حسابات {name}",
      text: "هذا الإعلان لم يعد في ذلك البلد، لذا لا يُبلّغ ذلك الحساب بأي شيء. | هذا الإعلان لم يعد في ذلك البلد، لذا لا تُبلّغ تلك الحسابات ({count}) بأي شيء.",
      remove: "إزالتها",
      removeTitle: "إزالة الحسابات الزائدة؟",
      removeMessage: "ستتم إزالة حساب {name} الذي بقي من قبل. لا يؤثر ذلك على الجهة التي تستخدمها الآن. | ستتم إزالة حسابات {name} ({count}) التي بقيت من قبل. لا يؤثر ذلك على الجهة التي تستخدمها الآن.",
      removed: "تمت إزالة الحسابات.",
      removeError: "تعذّرت إزالتها.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "رسالة المغادرة",
    subtitle: "تذكير بالمغادرة يُرسَل عشية المغادرة. اكتب نصك الخاص واستخدم المتغيرات المتاحة.",
    loading: "جارٍ التحميل…",
    enableTitle: "إرسال رسالة المغادرة",
    enableSub: "ستُرسَل تلقائيًا {day} في الساعة {time}.",
    dayLast: "يوم المغادرة",
    dayBefore: "اليوم السابق للمغادرة",
    cloneTitleNoun: "رسالة المغادرة",
    cloneItemNoun: "رسالة المغادرة",
    whenLabel: "موعد الإرسال",
    dayBeforeShort: "اليوم السابق",
    dayLastShort: "يوم المغادرة",
    atLabel: "في الساعة",
    timeHint: "يوم المغادرة لا يمكن أن يتجاوز الوقتُ وقتَ تسجيل المغادرة ({time}).",
    otaTitle: "الإرسال عبر OTA أيضًا",
    textLabel: "نص رسالة المغادرة",
    translate: "ترجمة",
    translating: "جارٍ الترجمة…",
    attach: "إرفاق",
    uploading: "جارٍ الرفع…",
    attachTitle: "مرفقات رسالة المغادرة",
    emojis: "الرموز التعبيرية",
    searchEmoji: "ابحث عن رمز…",
    variables: "المتغيرات",
    varsHint: "اضغط لإدراجها. تُستبدَل ببيانات الحجز الحقيقية عند الإرسال.",
    uploadDone: "تم الإرسال. جارٍ حفظه على الخادم…",
    attachLimits: "الصور وملفات PDF حتى {file} ميغابايت · مقاطع MP4 حتى {video} ميغابايت.",
    attachLimitsWhy: "هذه هي الحدود التي يسمح بها واتساب.",
    tipBefore: "استخدم",
    tipTextWord: "نص",
    tipMid: "لجعل شيء ما",
    tipBoldWord: "عريضًا",
    tipAfter: "(تنسيق واتساب). يتلقّى النزيل الرسالة بلغته إذا كانت مُهيّأة.",
    attachShared: "المرفقات · مشتركة بين جميع اللغات",
    delete: "حذف",
    autosaveNote: "تُحفَظ التغييرات تلقائيًا.",
    preview: "معاينة",
    online: "متصل",
    previewHint: "يتحدّث حسب إعداداتك",
    dayOfCheckout: "يوم المغادرة",
    eveOfCheckout: "عشية المغادرة",
    yourAccommodation: "مكان إقامتك",
    uploadSent: "{sent} من {total} ميغابايت",
    filesCount: "{count} ملفات",
    placeholder: "مثال: مرحبًا {guest} 👋 تنتهي إقامتك في {property} غدًا. وقت المغادرة هو {time}. شكرًا لزيارتك!",
    varGuestName: "اسم النزيل",
    varPropertyName: "اسم مكان الإقامة",
    varCheckoutTime: "وقت المغادرة",
    today: "اليوم",
    tomorrow: "غدًا",
    previewDefault: "مرحبًا، *{guest}* 👋\n\nنذكّرك بأن إقامتك في *{property}* تنتهي {when}.\n\n🕚 أقصى وقت للمغادرة هو *{time}*.\n\nشكرًا جزيلًا على إقامتك. رحلة موفقة! 😊",
    errVideoFormat: "❌ {name} مقطع فيديو {ext} وواتساب يدعم MP4 فقط. حوّله إلى MP4 وأعد رفعه.",
    errFileSize: "❌ {name} حجمه {size} ميغابايت والحد الأقصى {max} ميغابايت. ",
    errFileSizeVideo: "واتساب لا يدعم مقاطع أكبر: اضغطه أو اقتطعه.",
    errFileSizeFile: "واتساب لا يدعم ملفات أكبر.",
    attachUploaded: "تم رفع المرفق (المرفقات) بنجاح",
    attachUploadError: "خطأ أثناء رفع المرفقات",
    attachDeleted: "تم حذف المرفق",
    attachDeleteError: "تعذّر حذف المرفق",
    loadError: "تعذّر تحميل رسالة المغادرة.",
    translateEmpty: "اكتب الرسالة باللغة النشطة قبل الترجمة.",
    translateSuccess: "تمت ترجمة {count} لغات! راجع كل تبويب.",
    translatePartial: "{ok} مترجمة، {fail} فشلت.",
    translateError: "تعذّرت الترجمة. حاول مرة أخرى.",
    saved: "تم حفظ رسالة المغادرة",
    saveError: "تعذّر حفظ رسالة المغادرة.",
  },
};
